/*
import {
  hf,
  hfDTM,
  hfXLS,
  ht,
  _cv_60___Mz,
} from 'lib';
*/
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as hfXLS from "./_hfXLS";

import * as ihd from './ihd';
import * as icm from './icm';

import * as icvI1z___Mz from './icvI1z___Mz';

export const eptExlAsync = async (pz: { // 予約一覧
  _31r_fst: ht.n,
  yearMth: ht.s,
  ctt: 'e' | 'r', // content
//  i1zrs: ht.ls,
}) => { // 予約一覧

  const _dffz = icm.grtDffz({
    mode: pz.ctt,
    role: 's',
  });

  const _i1zrs = await icvI1z___Mz.loadI1zrLsAsync({
    _31r_fst: pz._31r_fst,
    yearMth: pz.yearMth,
    i1zrs1100iMnm: pz.ctt == 'r' ? 80 : undefined,
    i1zrs1200iMnm: pz.ctt == 'e' ? 70 : undefined,
    lwrType: 1,
  });

  const _fileName = `${_dffz.tgt}一覧_${hfDTM.f(hfDTM.getTdy(), 'YYYYMMDD')}.xlsx`;

  const _shtName = `${_dffz.tgt}一覧`;

  const _hdrs = [
    { key: 1100, header: 'No', width: 5, style: {} },
    { key: 1200, header: '予約ID', width: 5, style: {} },
    { key: 1300, header: '状況', width: 5, style: {} },
    { key: 1400, header: '団体番号', width: 5, style: {} },
    { key: 1500, header: '団体名', width: 20, style: {} },
    { key: 1600, header: '利用日', width: 10, style: {} },
    { key: 1700, header: '利用部屋', width: 20, style: {} },
    { key: 1800, header: '利用時間帯', width: 20, style: {} },
    { key: 1900, header: '利用料', width: 10, style: {} },
    { key: 2000, header: '利用料受領日', width: 10, style: {} },
    { key: 2100, header: '目的', width: 20, style: {} },
    { key: 2200, header: '備考', width: 20, style: {} },
  ];

  let _bdys = [] as ht.ls;
  _i1zrs.filter((_i1zrz: ht.dz) => (
    (pz.ctt == 'r' && _i1zrz.i1zrs1100i >= 80) || 
    (pz.ctt == 'e' && _i1zrz.i1zrs1200i >= 70)
  )).map((_i1zrz: ht.dz, _i1zrIdx: ht.n) => {
    const _i18rz = hf.get1(_i1zrz?.cldz?.i18rs, {});
    //hf.l(`icvI1z___Ez 395: ${hf.s(_i18rz)}`)
    const _i1z3z = hf.get1(_i1zrz?.cldz?.i1z3s, {});
    _bdys.push({
      1100: _i1zrIdx + 1,
      1200: _i1zrz._icn,
      1300: 
        pz.ctt == 'r' ? 
          ihd.r(ihd.f('i1zrs1100i').ls, _i1zrz.i1zrs1100i)
        : pz.ctt == 'e' ? 
          ihd.r(ihd.f('i1zrs1200i').ls, _i1zrz.i1zrs1200i)
        : '',
      1400: _i18rz.i18rab100s,
      1500: _i18rz._pfx,
      1600: hfDTM.f(_i1zrz.i1zrd3100s, '年月日曜'),
      1700: _i1zrz.i1zra1100s,
      1800: _i1zrz.i1zra1200s,
      1900: _i1z3z.i1z3m1110i,
      2000: _i1z3z.i1z3d2100s,
      2100: _i1zrz.i1zra4100s,
      2200: _i1zrz._ctn,
    });
  });

  hfXLS.saveAsync({
    fileName: _fileName,
    shts: [
      {
        shtName: _shtName,
        hdrs: _hdrs,
        bdys: _bdys,
      }
    ]
  })

};
